import type { DeskLayout } from '../models/desk-layout.model';

export const P28LK_DESKS: DeskLayout[] = [
  { name: 'M19', x: 126, y: 280.39, w: 43.214, h: 47.8448, rx: 9, reservationId: 1135 },
  { name: 'M20', x: 174, y: 280.39, w: 43.214, h: 47.8448, rx: 9, reservationId: 1136 },
  { name: 'M21', x: 222, y: 280.39, w: 43.214, h: 47.8448, rx: 9, reservationId: 1137 },
  { name: 'M13', x: 126, y: 334.534, w: 43.214, h: 47.8448, rx: 9, reservationId: 1129 },
  { name: 'M15', x: 222, y: 334.534, w: 43.214, h: 47.8448, rx: 9, reservationId: 1131 },
  { name: 'M14', x: 174, y: 334.534, w: 43.214, h: 47.8448, rx: 9, reservationId: 1130 },

  { name: 'M1', x: 126, y: 466.534, w: 43.214, h: 47.8448, rx: 9, reservationId: 1117, liftDesk: true },
  { name: 'M2', x: 174, y: 466.534, w: 43.214, h: 47.8448, rx: 9, reservationId: 1118 },
  { name: 'M3', x: 222, y: 466.534, w: 43.214, h: 47.8448, rx: 9, reservationId: 1119 },

  { name: 'M8', x: 174, y: 412.39, w: 43.214, h: 47.8448, rx: 9, reservationId: 1124 },
  { name: 'M7', x: 126, y: 412.39, w: 43.214, h: 47.8448, rx: 9, reservationId: 1123, liftDesk: true },
  { name: 'M9', x: 222, y: 412.39, w: 43.214, h: 47.8448, rx: 9, reservationId: 1125 },

  { name: 'M22', x: 330, y: 280.39, w: 43.214, h: 47.8448, rx: 9, reservationId: 1138, liftDesk: true },
  { name: 'M23', x: 378, y: 280.39, w: 43.214, h: 47.8448, rx: 9, reservationId: 1139 },
  { name: 'M24', x: 426, y: 280.39, w: 43.214, h: 47.8448, rx: 9, reservationId: 1140 },
  { name: 'M16', x: 330, y: 334.534, w: 43.214, h: 47.8448, rx: 9, reservationId: 1132, liftDesk: true },
  { name: 'M17', x: 378, y: 334.534, w: 43.214, h: 47.8448, rx: 9, reservationId: 1133 },
  { name: 'M18', x: 426, y: 334.534, w: 43.214, h: 47.8448, rx: 9, reservationId: 1134 },

  { name: 'M10', x: 330, y: 412.39, w: 43.214, h: 47.8448, rx: 9, reservationId: 1126 },
  { name: 'M11', x: 378, y: 412.39, w: 43.214, h: 47.8448, rx: 9, reservationId: 1127 },
  { name: 'M12', x: 426, y: 412.39, w: 43.214, h: 47.8448, rx: 9, reservationId: 1128 },
  { name: 'M4', x: 330, y: 466.534, w: 43.214, h: 47.8448, rx: 9, reservationId: 1120 },
  { name: 'M6', x: 426, y: 466.534, w: 43.214, h: 47.8448, rx: 9, reservationId: 1122 },
  { name: 'M5', x: 378, y: 466.534, w: 43.214, h: 47.8448, rx: 9, reservationId: 1121 },

  { name: 'M26', x: 678.822, y: 566, w: 43.8218, h: 47.8448, rx: 9, reservationId: 1142 },
  { name: 'M25', x: 630, y: 566, w: 43.8218, h: 47.8448, rx: 9, reservationId: 1141, liftDesk: true },
  { name: 'M28', x: 678.822, y: 512, w: 43.8218, h: 47.8448, rx: 9, reservationId: 1144 },
  { name: 'M27', x: 630, y: 512, w: 43.8218, h: 47.8448, rx: 9, reservationId: 1143, liftDesk: true },
  { name: 'M30', x: 676.822, y: 408, w: 43.8218, h: 47.8448, rx: 9, reservationId: 1146 },
  { name: 'M29', x: 628, y: 408, w: 43.8218, h: 47.8448, rx: 9, reservationId: 1145 },
  { name: 'M32', x: 676.822, y: 354, w: 43.8218, h: 47.8448, rx: 9, reservationId: 1148 },
  { name: 'M31', x: 628, y: 354, w: 43.8218, h: 47.8448, rx: 9, reservationId: 1147 },
  { name: 'M34', x: 676.822, y: 250, w: 43.8218, h: 47.8448, rx: 9, reservationId: 1150 },
  { name: 'M33', x: 628, y: 250, w: 43.8218, h: 47.8448, rx: 9, reservationId: 1149 },
  { name: 'M36', x: 676.822, y: 196, w: 43.8218, h: 47.8448, rx: 9, reservationId: 1152 },
  { name: 'M35', x: 628, y: 196, w: 43.8218, h: 47.8448, rx: 9, reservationId: 1151 },

  { name: 'M39', x: 598.845, y: 21.9991, w: 43.8218, h: 47.8448, rx: 9, reservationId: 1428 },
  { name: 'M38', x: 647.845, y: 21.9991, w: 43.8218, h: 47.8448, rx: 9, reservationId: 1427 },
  { name: 'M37', x: 696.845, y: 21.9991, w: 43.8218, h: 47.8448, rx: 9, reservationId: 1426 }
];